import React from 'react';
import { stringUtils } from '../_common/stringUtils';
import { clientApiService } from '../_services/clientapi.service';
import {deviceType,mobileVendor,mobileModel,osVersion,osName} from 'react-device-detect';
import  queryString  from 'query-string';

const PAGE_STATE_UNKNOWN='page-unknown';
const PAGE_STATE_TOS_NEED_SIGN='page-need-tos-sign';
const PAGE_STATE_POST_SCAN_COMPLETED='page-post-scan-completed';
const PAGE_STATE_USER_CREATED_BUT_NOT_SCANNED='page-user-created-not-scanned';
const PAGE_STATE_USER_READY='page-user-ready';
const PAGE_STATE_USER_FAILED='page-user-failed';
const PAGE_STATE_USER_PENDING='page-user-pending';
const PAGE_STATE_USER_RESCAN='page-user-rescan';
const PAGE_STATE_NEW_USER='page-new-user';
const PAGE_STATE_SHOW_RECOMMENDATION='page-show-recommendation';
const PAGE_STATE_SHOW_TAHNKYOU='page-show-thankyou';
const PAGE_STATE_WIDGET_CLOSED='page-widget-closed';
const PAGE_STATE_SHARE='page-share';
const PAGE_STATE_ERROR='page-error';
const PAGE_STATE_PROCESSING='page-processing';
const PAGE_STATE_TUTORIAL='page-tutorial';
const PAGE_STATE_OPENING='page-opening-screen';
const PAGE_STATE_NOT_VERTICAL = 'page-not-vertical'
const PAGE_STATE_TILTOMETER='page-tiltometer';
const PAGE_STATE_VOLUME='page-volume';
const PAGE_STATE_TERMS_OF_USE='page-terms-of-service';
const PAGE_STATE_WEB_SCAN='page-webscan';
const PAGE_STATE_WEB_SCAN_UPLOAD_COMPLETED='page-webscan-upload-completed';
const PAGE_STATE_PRIVACY_POLICY='page-privacy-policy';
const PAGE_STATE_TEST_NEW='test_new';
const PAGE_NO_CAMERA='page-no-camera';
const PAGE_NO_TILT_PERMISSION='page-no-tilt-PERMISSION';
const PAGE_NO_RECOMMENDATION='page-no-recommendation';

export const SizerAppAPI = {
  StartScan,
  SetWebViewData,
  ResetWebViewData,
  UseNewUpload,
  AgreeTOS,
  OverrideWidgetConfig,
  DeveloperOptions,
  openUrlWindow,
  getDeviceConfiguration,
  EnablePlaceYourDevicePose,
  SkipTiltIfOK,
  CommonAppPreset,
  EnablePingAfterPose,
  GetDeviceDetails,
  GetWidgetConfig,
  PAGE_STATE_UNKNOWN,
  PAGE_STATE_TOS_NEED_SIGN,
  PAGE_STATE_POST_SCAN_COMPLETED,
  PAGE_STATE_USER_CREATED_BUT_NOT_SCANNED,
  PAGE_STATE_USER_READY,
  PAGE_STATE_USER_RESCAN,
  PAGE_STATE_USER_FAILED,
  PAGE_STATE_USER_PENDING,
  PAGE_STATE_NEW_USER,
  PAGE_STATE_SHARE,
  PAGE_STATE_TUTORIAL,
  PAGE_STATE_ERROR,
  PAGE_STATE_OPENING,
  PAGE_STATE_VOLUME,
  PAGE_STATE_PROCESSING,
  PAGE_STATE_NOT_VERTICAL,
  PAGE_STATE_TILTOMETER,
  PAGE_STATE_WEB_SCAN,
  PAGE_STATE_PRIVACY_POLICY,
  PAGE_STATE_SHOW_RECOMMENDATION,
  PAGE_STATE_SHOW_TAHNKYOU,
  PAGE_STATE_TERMS_OF_USE,
  PAGE_STATE_TEST_NEW,
  PAGE_STATE_WIDGET_CLOSED,
  PAGE_NO_CAMERA,
  PAGE_NO_TILT_PERMISSION,
  PAGE_NO_RECOMMENDATION
}

const sizerAcitivitiesEnabled = true;

export function OverrideWidgetConfig(params)
{
    window.sizerConfigOverride = {};
    if (params.clientid) window.sizerConfigOverride.clientid = params.clientid;
    if (params.registration) window.sizerConfigOverride.registration = params.registration;
    if (params.endOfScan) window.sizerConfigOverride.endOfScan = params.endOfScan;
    if (params.garmentid) window.sizerConfigOverride.garmentid = params.garmentid;
    
}

export function GetWidgetConfig()
{
    const rootTag = document.getElementById('SIZER_SIZE_WIDGET')
    let topmost = rootTag?.getAttribute('data-topmost');
    const urlQuery = new URLSearchParams(document.location.search)
    const topmost_quary = urlQuery.get('topmostSizer');
    if(topmost_quary) topmost = topmost_quary;


    var testMGV2URL = urlQuery.get('testMGV2URL')?urlQuery.get('testMGV2URL'):'';
    var urlTheme = urlQuery.get('theme')?urlQuery.get('theme'):'';


    const widgetConfig = {
        rootTag: rootTag,

        // TODO: these 3 need to be removed!
        placement: rootTag?.getAttribute('placement'),
        
        
        type: rootTag?.getAttribute('type'),


        mode: rootTag?.getAttribute('data-mode') || 'scan',

        // endOfScan: What is displayed at the end of the scan
        //            recommendation :  show size recommendation for a garment
        //            measurements:     show the body measurements of the user
        //            thankyou:         show thank you screen
        endOfScan: rootTag?.getAttribute('data-end-of-scan') || 'recommendation',

        // startOfScan: What is the first screen at the beginning of the scan
        //            button : (default) start button
        //            tutorial : start immidiatly with tutorial screen (mobile only)
        startOfScan: rootTag?.getAttribute('data-start-of-scan') || 'button',

        // clientid: cliend id as defined on Sizer Dashboard for that company
        clientid: rootTag?.getAttribute('data-clientid'),

        // userid: open the widget for that specific userid
        userid: rootTag?.getAttribute('data-userid'),

        // garmentid: the garmentid from Sizer Dashboard
        //            that is used for displaying size recommendation
        garmentid: rootTag?.getAttribute('data-garmentid'),

        // recommendation-method: how to do recommendation
        // by-garment: system expects to have data-garmentid, and recommendit (default)
        // MGV2: (Magelan Version 2) automatically by the URL
        recommendationMethod: rootTag?.getAttribute('data-recommendation-method'),

        // debug mode: for internal use only.
        //             if true, debug mode is enabled all the time
        debug: rootTag?.getAttribute('data-debug'),

        // resetOnreload mode: on each reload of the widget
        //             the user is reset, and scan start from scartch
        resetOnClick: rootTag?.getAttribute('data-reset-on-click'),

        // backgroundWrapperColor: bg for the widget wrapper
        backgroundWrapperColor: rootTag?.getAttribute('data-background-wrapper-color') || '',

        buttonStyle: rootTag?.getAttribute('data-button-style') || '',

        // lang: language for the widget
        //       supported languages: 'en', 'de', 'fr', 'es'
        lang: rootTag?.getAttribute('data-lang'),

        // theme: UI theme for the widget
        //        a theme folder with that name must exists 
        //        on the /_themes/ folder
        theme: rootTag?.getAttribute('data-theme'),

        // menu-placement: A default position for the menu on the registration
        //                 form. 'top' | 'bottom' | 'auto'
        //                 default: 'top'
        menuPlacement: rootTag?.getAttribute('data-menu-placement')  || 'top',

        // testMGV2URL : URL for simulating URL for the MGV2 system
        //               if not provided taken from page containinng
        //               the widget
        testMGV2URL : testMGV2URL,

        // registration: Information for the user registration
        // example: "fields": { 	
	    //  "gender": {"show": false,"value": "male"}, 
        //  "height_cm": {"show": true,"value": 182}, 
        //  "name": {"show": true,"value": "John Doe"}, 
        //  "email": {"value": "@auto@"}
        registration: rootTag?.getAttribute('data-registration'),

        // topmost: The widget will be created as the last component
        // on the page (with window.add), as a result will appear on
        // top of all other components 	
        // 
        // values:
        //     "true" : enables the topmost feature
        topmost: topmost
    }

    if (widgetConfig.testMGV2URL!=='') {
        widgetConfig.recommendationMethod ='MGV2';
    }

    if (urlTheme && urlTheme !=='') {
        widgetConfig.theme =urlTheme;
    }


    if (window.sizerConfigOverride && window.sizerConfigOverride.clientid) widgetConfig.clientid = window.sizerConfigOverride.clientid;
    if (window.sizerConfigOverride && window.sizerConfigOverride.registration) widgetConfig.registration = window.sizerConfigOverride.registration;
    if (window.sizerConfigOverride && window.sizerConfigOverride.endOfScan) widgetConfig.endOfScan = window.sizerConfigOverride.endOfScan;
    if (window.sizerConfigOverride && window.sizerConfigOverride.garmentid) widgetConfig.garmentid = window.sizerConfigOverride.garmentid;
    
    return widgetConfig;
}

export function getDeviceConfiguration(query, readyCallback)
{
    const parsed = queryString.parse(query);
    var deviceId = parsed.did?parsed.did:'';

    if (deviceId === undefined || deviceId=== null || deviceId === '') {
        readyCallback(null);
        return;
    }

    clientApiService.getDeviceConfiguration({did:deviceId})
    .then(response => {
      if (response.resultCode==='OK') {
        if (response.data ){
            var json = {};
            try {
                json = JSON.parse(response.data.json);
                readyCallback(json);
            }
            catch (e) {
                readyCallback(null);
            }
          return;
        }
        else {
            readyCallback(null);
        }
      }
    });
}

function getSafeValue(val)
{
    if (!val)
        return '';

    return val.toLowerCase();
}

export function GetDeviceDetails()
{   
    var value;
    var locale = '';
    var language = '';
  
    //detect the language preference of the user's browser
    language = navigator.language || navigator.userLanguage; 
    const browserLocales = navigator.languages;
    for (var index = 0; index <browserLocales.length; ++index) {
        value = browserLocales[index];
        if (value.includes("-")) 
        {
            locale = value;
            break;
        }
    }
   
    return ({
        osName:getSafeValue(osName),
        osVersion: getSafeValue(osVersion),
        deviceType: getSafeValue(deviceType), // iphone, ipad, galaxy S10,
        mobileVendor:getSafeValue(mobileVendor),
        mobileModel:getSafeValue(mobileModel),
        locale: getSafeValue(locale),
        language: getSafeValue(language)
    });
}


export function DeveloperOptions(props)
{
    var deviceDetails = GetDeviceDetails();
    var qs = queryString.parse(window.location.search);

    var allParams=[];
    allParams.push(<strong key={'P_'+stringUtils.generateId(6)}>URL Parameters<br/></strong>);
    for (const [key, value] of Object.entries(qs)) {
        allParams.push(<span key={'P_'+stringUtils.generateId(6)}>{key}:{value}<br/></span>)
    }
    allParams.push(<span key={'P_'+stringUtils.generateId(6)}><br/></span>)

    if (props.additionalAppData!==undefined) {
        allParams.push(<strong key={'P_'+stringUtils.generateId(6)}>Internal App data<br/></strong>);
        for (const [key, value] of Object.entries(props.additionalAppData)) {
            allParams.push(<span key={'P_'+stringUtils.generateId(6)}>{key}:{value}<br/></span>)
        }
    }
    
    var uAgent = navigator.userAgent;
    allParams.push(<span>User-agent:{uAgent}<br/></span>)
    allParams.push(<span>Device-Details:{JSON.stringify(deviceDetails)}<br/></span>)
    allParams.push(<span>Url-Details:{window.location.href}<br/></span>)
    return (
        <div className="card fs--2 border border-primary" style={{"max-height":"150px","overflow":"scroll"}}>
            {allParams}
            <div>
            <button className='btn-sm fs--2 pl-1 pr-1' onClick={()=>window.location='sizer://reset'}>Reset App</button>
            <button className='btn-sm fs--2 pl-1 pr-1 mt-1' onClick={()=>SizerAppAPI.StartScan()}>Start Scan</button>

            <br/>
            <br/>
                <a href='/#' onClick={()=>SizerAppAPI.SkipTiltIfOK(true)}> SkipTiltIfOK(true)</a>&nbsp;|&nbsp;
                <a href='/#' onClick={()=>SizerAppAPI.SkipTiltIfOK(false)}> SkipTiltIfOK(false)</a><br/>
                <a href='/#' onClick={()=>SizerAppAPI.EnablePingAfterPose(true)}> EnablePingAfterPose(true)</a>&nbsp;|&nbsp;
                <a href='/#' onClick={()=>SizerAppAPI.EnablePingAfterPose(false)}> EnablePingAfterPose(false)</a><br/>
                <a href='/#' onClick={()=>SizerAppAPI.EnablePlaceYourDevicePose(false)}> EnablePlaceYourDevicePose(false)</a><br/>
                <a href='/#' onClick={()=>window.location='sizer://setoption?EnablePlaceYourDevicePose=true&enablePingAfterPose=true'}>EnablePlaceYourDevicePose=true&enablePingAfterPose=true</a><br/>
                <a href='/#' onClick={()=>window.location='sizer://setoption?EnablePushMessages=true'}>EnablePushMessages=true</a><br/>
                <a href='/#' onClick={()=>window.location='sizer://setoption?skipVolumeScreen=true'}>skipVolume=true</a><br/>
                <a href='/#' onClick={()=>window.location='sizer://setoption?skipVolumeScreen=false'}>skipVolume=false</a><br/>
               
                
                
                <br/>
                <a href='/#' onClick={()=>SizerAppAPI.CommonAppPreset()}>Wacoal App Preset</a><br/>
            </div>
        </div>
    )

}



export function StartScan(skipTutorial=false) {
    if (!sizerAcitivitiesEnabled) return;

    if (skipTutorial)
        window.location='sizer://scan?skiptutorial=true'
    else
        window.location='sizer://scan';    
}

export function AgreeTOS() {
    if (!sizerAcitivitiesEnabled) return;
    window.location='sizer://setoption?TOSsigned=true';    
}

//-- Common App Preset
export function CommonAppPreset() {
    if (!sizerAcitivitiesEnabled) return;
    window.location='sizer://setoption?enablePingAfterPose=true&skipTiltIfOK=false';
}

//-- Ping is heared and camera shutter is displayed at the end of
//   the poses
export function EnablePingAfterPose(isEnabled=true) {
    if (!sizerAcitivitiesEnabled) return;
    window.location='sizer://setoption?enablePingAfterPose='+((isEnabled)?'true':'false');    
} 

//-- Enable/Disable the Place Your Device Pose 
export function EnablePlaceYourDevicePose(isEnabled=true) {
    if (!sizerAcitivitiesEnabled) return;
    window.location='sizer://setoption?enablePlaceYourDevicePose='+((isEnabled)?'true':'false');    
}

//-- If enabled, the Tilt screen is skipped if device is positioned correctly
export function SkipTiltIfOK(isEnabled=true) {
    if (!sizerAcitivitiesEnabled) return;
    window.location='sizer://setoption?skipTiltIfOK='+((isEnabled)?'true':'false');
}

export function SetWebViewData(params) {
    if (!sizerAcitivitiesEnabled) return;
//    console.log('SetWebViewData');
    var urlP = queryString.stringify(params);
    window.location='sizer://setdata?'+urlP;
}

export function ResetWebViewData() {
    if (!sizerAcitivitiesEnabled) return;
//    console.log('ResetWebViewData');
    window.location='sizer://reset';
}

export function UseNewUpload() {
    if (!sizerAcitivitiesEnabled) return;
    window.location='sizer://setoption?newupload=true';
}

export function openUrlWindow(urlToOpen) {
    if (!sizerAcitivitiesEnabled) return;
    window.location='sizer://link:'+urlToOpen;
}
